import {lazy} from 'react';

export const SearchLazy = lazy(() => import(/* webpackChunkName: "search" */ '.'));
